import { hpe } from 'grommet-theme-hpe';

const theme = hpe;

export default theme;
